import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { UsersListComponent } from './users-list/users-list.component';
import { UsersFiltersComponent } from './users-filters/users-filters.component';
import { PatchAdminUsersFiltersCommandHandler } from '../../application/handlers';

@Component({
  selector: 'lib-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, UsersListComponent, UsersFiltersComponent, PageLayoutComponent],
  providers: [PatchAdminUsersFiltersCommandHandler]
})
export class UsersComponent {
  private readonly patchAdminUsersFiltersCommandHandler: PatchAdminUsersFiltersCommandHandler = inject(
    PatchAdminUsersFiltersCommandHandler
  );

  clearContext(): void {
    this.patchAdminUsersFiltersCommandHandler.reset().subscribe();
  }
}
